import React from "react";
import { Menu, useResourceDefinitions } from "react-admin";
import { Box, Typography } from "@mui/material";
import SecurityIcon from "@mui/icons-material/Security";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

/**
 * Custom Menu with resource grouping by service
 */
export const CustomMenu = () => {
  const resources = useResourceDefinitions();

  // Auth Service resources
  const authResources = ["auth-users", "oauth-clients"];

  // Break3 Backend resources
  const break3Resources = [
    "users",
    "challenges",
    "challengeUpdates",
    "supplements",
    "supplementOrders",
    "paymentTransactions",
    "chatMessages",
    "subscriptionPlans",
    "subscriptionLimiters",
    "userSubscriptions",
    "subscriptionStats",
    "limiterStats",
    "notifications",
    "notificationQueueMonitor",
    "notificationStats",
  ];

  return (
    <Box>
      {/* Dashboard */}
      <Menu.DashboardItem />

      {/* Auth Service Group */}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="caption"
          sx={{
            px: 2,
            py: 1,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            color: "text.secondary",
            fontWeight: 600,
            textTransform: "uppercase",
            fontSize: "0.75rem",
          }}
        >
          <SecurityIcon sx={{ fontSize: 16 }} />
          Auth Service
        </Typography>
        {authResources.map((name) =>
          resources[name] ? <Menu.ResourceItem key={name} name={name} /> : null,
        )}
      </Box>

      {/* Break3 Backend Group */}
      <Box sx={{ mt: 2 }}>
        <Typography
          variant="caption"
          sx={{
            px: 2,
            py: 1,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            color: "text.secondary",
            fontWeight: 600,
            textTransform: "uppercase",
            fontSize: "0.75rem",
          }}
        >
          <FitnessCenterIcon sx={{ fontSize: 16 }} />
          Break3 Backend
        </Typography>
        {break3Resources.map((name) =>
          resources[name] ? <Menu.ResourceItem key={name} name={name} /> : null,
        )}
      </Box>
    </Box>
  );
};
